/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

type Props = {
  className: string
  color: string
  title: string
  description: string
  progress: string
}

const StatisticsWidget6: React.FC<Props> = ({ className, color, title, description, progress }) => {
  return (
    <div className={`card !bg-[#c4ede1] ${className}`}>
      {/* begin::Body */}
      <div className='card-body my-3'>
        <a href='#' className={`card-title fw-bold !text-[#052e22] fs-5 mb-3 d-block`}>
          {description}
        </a>

        <div className='py-1'>
          <span className='!text-[#052e22] fs-1 fw-bold me-2'>
            {(progress &&
              parseFloat(progress).toFixed(
                [
                  'Recycling Facility',
                  'Waste Collector',
                  'End of Waste Processors',
                  'Waste Supplier',
                  'Supply chain Facilities',
                ].includes(description)
                  ? 0
                  : 2
              )) ||
              ''}
          </span>

          <span className='fw-semibold !text-[#052e22] fs-7'>{title}</span>
        </div>
      </div>
      {/* end:: Body */}
    </div>
  )
}

export { StatisticsWidget6 }
